import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * FilterTemplateValuesApi - axios parameter creator
 * @export
 */
const FilterTemplateValuesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options = {}) => {
            const localVarPath = `/v1/FilterTemplateValues/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [attributeId]
         * @param {number} [filterTemplateValueId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttributeFiltersTemplate: async (attributeId, filterTemplateValueId, options = {}) => {
            const localVarPath = `/v1/FilterTemplateValues/GetAttributeFiltersTemplate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (attributeId !== undefined) {
                localVarQueryParameter['attributeId'] = attributeId;
            }
            if (filterTemplateValueId !== undefined) {
                localVarQueryParameter['filterTemplateValueId'] = filterTemplateValueId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableFiltersByFilterTemplate: async (id, options = {}) => {
            const localVarPath = `/v1/FilterTemplateValues/GetAvailableFiltersByFilterTemplate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByFilterTemplate: async (id, options = {}) => {
            const localVarPath = `/v1/FilterTemplateValues/GetByFilterTemplate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/FilterTemplateValues/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {FilterTemplateValueToken} [FilterTemplateValueToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (FilterTemplateValueToken, options = {}) => {
            const localVarPath = `/v1/FilterTemplateValues/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(FilterTemplateValueToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {Array<FilterTemplateValueToken>} [FilterTemplateValueToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertBulk: async (FilterTemplateValueToken, options = {}) => {
            const localVarPath = `/v1/FilterTemplateValues/InsertBulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(FilterTemplateValueToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/FilterTemplateValues/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {FilterTemplateValueToken} [FilterTemplateValueToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (FilterTemplateValueToken, options = {}) => {
            const localVarPath = `/v1/FilterTemplateValues/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(FilterTemplateValueToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {FilterTemplateExtraValueToken} [FilterTemplateExtraValueToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAttributeFiltersTemplate: async (FilterTemplateExtraValueToken, options = {}) => {
            const localVarPath = `/v1/FilterTemplateValues/UpdateAttributeFiltersTemplate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(FilterTemplateExtraValueToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {Array<FilterTemplateValueToken>} [FilterTemplateValueToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBulk: async (FilterTemplateValueToken, options = {}) => {
            const localVarPath = `/v1/FilterTemplateValues/UpdateBulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(FilterTemplateValueToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * FilterTemplateValuesApi - functional programming interface
 * @export
 */
const FilterTemplateValuesApiFp = function (configuration) {
    const localVarAxiosParamCreator = FilterTemplateValuesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilterTemplateValuesApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [attributeId]
         * @param {number} [filterTemplateValueId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttributeFiltersTemplate(attributeId, filterTemplateValueId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttributeFiltersTemplate(attributeId, filterTemplateValueId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilterTemplateValuesApi.getAttributeFiltersTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableFiltersByFilterTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableFiltersByFilterTemplate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilterTemplateValuesApi.getAvailableFiltersByFilterTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByFilterTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByFilterTemplate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilterTemplateValuesApi.getByFilterTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilterTemplateValuesApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {FilterTemplateValueToken} [FilterTemplateValueToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(FilterTemplateValueToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(FilterTemplateValueToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilterTemplateValuesApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {Array<FilterTemplateValueToken>} [FilterTemplateValueToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insertBulk(FilterTemplateValueToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insertBulk(FilterTemplateValueToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilterTemplateValuesApi.insertBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilterTemplateValuesApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {FilterTemplateValueToken} [FilterTemplateValueToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(FilterTemplateValueToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(FilterTemplateValueToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilterTemplateValuesApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {FilterTemplateExtraValueToken} [FilterTemplateExtraValueToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAttributeFiltersTemplate(FilterTemplateExtraValueToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAttributeFiltersTemplate(FilterTemplateExtraValueToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilterTemplateValuesApi.updateAttributeFiltersTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {Array<FilterTemplateValueToken>} [FilterTemplateValueToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBulk(FilterTemplateValueToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBulk(FilterTemplateValueToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilterTemplateValuesApi.updateBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * FilterTemplateValuesApi - factory interface
 * @export
 */
const FilterTemplateValuesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FilterTemplateValuesApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options) {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [attributeId]
         * @param {number} [filterTemplateValueId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttributeFiltersTemplate(attributeId, filterTemplateValueId, options) {
            return localVarFp.getAttributeFiltersTemplate(attributeId, filterTemplateValueId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableFiltersByFilterTemplate(id, options) {
            return localVarFp.getAvailableFiltersByFilterTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByFilterTemplate(id, options) {
            return localVarFp.getByFilterTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {FilterTemplateValueToken} [FilterTemplateValueToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(FilterTemplateValueToken, options) {
            return localVarFp.insert(FilterTemplateValueToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {Array<FilterTemplateValueToken>} [FilterTemplateValueToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertBulk(FilterTemplateValueToken, options) {
            return localVarFp.insertBulk(FilterTemplateValueToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {FilterTemplateValueToken} [FilterTemplateValueToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(FilterTemplateValueToken, options) {
            return localVarFp.update(FilterTemplateValueToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {FilterTemplateExtraValueToken} [FilterTemplateExtraValueToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAttributeFiltersTemplate(FilterTemplateExtraValueToken, options) {
            return localVarFp.updateAttributeFiltersTemplate(FilterTemplateExtraValueToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {Array<FilterTemplateValueToken>} [FilterTemplateValueToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBulk(FilterTemplateValueToken, options) {
            return localVarFp.updateBulk(FilterTemplateValueToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FilterTemplateValuesApi - object-oriented interface
 * @export
 * @class FilterTemplateValuesApi
 * @extends {BaseAPI}
 */
class FilterTemplateValuesApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterTemplateValuesApi
     */
    getAll(options) {
        return FilterTemplateValuesApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [attributeId]
     * @param {number} [filterTemplateValueId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterTemplateValuesApi
     */
    getAttributeFiltersTemplate(attributeId, filterTemplateValueId, options) {
        return FilterTemplateValuesApiFp(this.configuration).getAttributeFiltersTemplate(attributeId, filterTemplateValueId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterTemplateValuesApi
     */
    getAvailableFiltersByFilterTemplate(id, options) {
        return FilterTemplateValuesApiFp(this.configuration).getAvailableFiltersByFilterTemplate(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterTemplateValuesApi
     */
    getByFilterTemplate(id, options) {
        return FilterTemplateValuesApiFp(this.configuration).getByFilterTemplate(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterTemplateValuesApi
     */
    getById(id, options) {
        return FilterTemplateValuesApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {FilterTemplateValueToken} [FilterTemplateValueToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterTemplateValuesApi
     */
    insert(FilterTemplateValueToken, options) {
        return FilterTemplateValuesApiFp(this.configuration).insert(FilterTemplateValueToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {Array<FilterTemplateValueToken>} [FilterTemplateValueToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterTemplateValuesApi
     */
    insertBulk(FilterTemplateValueToken, options) {
        return FilterTemplateValuesApiFp(this.configuration).insertBulk(FilterTemplateValueToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterTemplateValuesApi
     */
    remove(id, options) {
        return FilterTemplateValuesApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {FilterTemplateValueToken} [FilterTemplateValueToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterTemplateValuesApi
     */
    update(FilterTemplateValueToken, options) {
        return FilterTemplateValuesApiFp(this.configuration).update(FilterTemplateValueToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {FilterTemplateExtraValueToken} [FilterTemplateExtraValueToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterTemplateValuesApi
     */
    updateAttributeFiltersTemplate(FilterTemplateExtraValueToken, options) {
        return FilterTemplateValuesApiFp(this.configuration).updateAttributeFiltersTemplate(FilterTemplateExtraValueToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {Array<FilterTemplateValueToken>} [FilterTemplateValueToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterTemplateValuesApi
     */
    updateBulk(FilterTemplateValueToken, options) {
        return FilterTemplateValuesApiFp(this.configuration).updateBulk(FilterTemplateValueToken, options).then((request) => request(this.axios, this.basePath));
    }
}

export { FilterTemplateValuesApi, FilterTemplateValuesApiAxiosParamCreator, FilterTemplateValuesApiFactory, FilterTemplateValuesApiFp };
//# sourceMappingURL=filter-template-values-api.js.map
